module.exports = __webpack_public_path__ + "img/fossil4Img1.5f62df36.jpg";